jQuery(document).ready(function($) {

  /********* STICKY MENU **********/
  var stickyNavTop = $('#main-header').offset().top;

  var stickyNav = function(){
    var scrollTop = $(window).scrollTop();

    if (scrollTop > stickyNavTop) {
        $('#main-header').addClass('sticky');
    } else {
        $('#main-header').removeClass('sticky');
    }
  };

  stickyNav();

  $(window).scroll(function() {
      stickyNav();
  });


  let initKeyfigures = function(){


    if($('.block_keyfigures .count').length > 0){
        var count = false;
        $(window).scroll(function () {

            if(count == false){
                if($(window).scrollTop() >= ($('.block_keyfigures').offset().top - 300)){
                    count = true;
                    $('.count').each(function () {
                        var nb = $(this).text().replace(' ','');
                        var float = '';
                        var pref = '';
                        //console.log(nb.search(',5'));
                        if(nb.search(',5') != -1){
                          float = ',5';
                          nb = nb.replace(',5', '');
                        }
                        if(nb.indexOf('+') >= 0){
                          pref = '+';
                          nb = nb.replace('+', '');
                        }
                        $(this).prop('Counter',($(this).text()/4)*3).animate({
                            Counter: nb
                        }, {
                            duration: 1000,
                            easing: 'swing',
                            step: function (now) {
                                $(this).text(pref+Math.ceil(now)+float);
                            }
                        });
                    });
                }
            }

        });
    }

  }


  let initNews = function(){
    if( $('.load-more .list').length > 0 ){

        /***************************
        *     RELOAD MORE LIST
        ***************************/
       var load = false;
       var currentPage = $('.load-more .list .nav').data('paged');
       var maxNumPages = $('.load-more .list .nav').data('max');
       var postsPerPage = $('.load-more .list .nav').data('perpage');
       var foundPosts = $('.load-more .list .nav').data('foundposts');
       var tax = $('.load-more .taxs a.selected').data('id');

       if (foundPosts > postsPerPage && maxNumPages > 1) {
           $('.load-more .more').show();
       }
       if(currentPage + 1 > maxNumPages) $('.load-more .more').hide();

       $('.load-more .more a').click(function(e){
           e.preventDefault();

           if (!load && ($('.load-more .list .item').length >= postsPerPage) && ($('.load-more .list .item').length < foundPosts)) {

               load = true;
               $('.load-more .loader').show();
               $('.load-more .more').hide();

               var nextPage = currentPage + 1;

               if (nextPage <= maxNumPages) {

                   $.ajax({
                       url: $('.load-more .list .nav').data('url'),
                       data: {
                           paged: nextPage,
                           category_id : tax
                       },
                       success: function(data) {
                           if (data != '') {

                              currentPage++;
                              $('.load-more .list .nav').append(data);

                               load = false;
                               $('.load-more .loader').hide();

                              if (nextPage == maxNumPages) {
                                  $('.load-more .more').hide();
                              }
                              else {
                                  $('.load-more .more').show();
                              }
                              $('.load-more .total .count').html($('.load-more .list .item').length);
                              $('.load-more .total .tt').html(foundPosts);
                           }

                       }
                   });
               }
           }
       });
   }
 }

 let initJobs = function(){
    if($(".recrutement").length > 0){
        $(".filters select").change(function(){
            //$('.filters form').submit();
            var value = $('.select-types').find(":selected").val();
            var value2 = $('.select-domaines').find(":selected").val();
            
            $('.alert-warning').hide();
            $('#jobs_offers__list .job').hide();

            if(value == '' && value2 ==''){
                $('#jobs_offers__list .job').fadeIn();
            }
            else{
                if(value != '' && value2 !='')
                    $('#jobs_offers__list .job.term_'+value+'.term_'+value2).fadeIn();
                else{
                    $('#jobs_offers__list .job.term_'+value).fadeIn();
                    $('#jobs_offers__list .job.term_'+value2).fadeIn();
                }
            }
                
            var visible = false 
            $( "#jobs_offers__list .job" ).each(function( index ) {
                if($( this ).css("display") != "none") visible = true;
            });
            if(visible == false){
                $('.alert-warning').fadeIn();
            }
            
        });
    }
 }


  let initMain = function(){
    initKeyfigures();
    initNews();
    initJobs();
  }

  initMain();

});
